import { useState } from "react";
import { dt } from "src/utils/documentsI18n";
import { formatMoneyWithCurrency } from "src/utils/formatter";

// Estados traducidos en documents.json -> status.nomina.*


const NominaContent = ({ data }) => {

  return (
    <>
      <div className="tw-flex tw-py-3 tw-justify-between">
        <div className="tw-flex-row tw-gap-1">
          <p className="tw-text-md tw-font-sans tw-font-semibold !tw-p-0 !tw-m-0">{data?.nominaName}</p>
          <p className="tw-text-sm tw-font-normal tw-font-sans !tw-p-0 !tw-m-0">{data?.emailSelector}</p>
        </div>
        <div className="tw-flex tw-gap-12 tw-items-center">
          {/* Monto */}
          <div className="">
            <p className="tw-text-md tw-font-medium tw-font-sans !tw-p-0 !tw-m-0">{formatMoneyWithCurrency(data?.amount)}</p>
          </div>
          {/* Estado */}
          <div className={`tw-px-2 tw-py-1 tw-rounded-md tw-w-[100px] tw-text-center
            ${data?.isMatched === true ?
              'tw-bg-green-50 tw-text-green-500'
              : data?.status === 'APPROVED' && !data?.isMatched
                ? 'tw-bg-gray-50 tw-text-gray-500'
                : data?.status === 'REJECTED'
                  ? 'tw-bg-red-50 tw-text-red-500'
                  : data?.status === 'IN_CREATED_NOMINA'
                    ? 'tw-bg-yellow-50 tw-text-yellow-500'
                    : 'tw-bg-yellow-50 tw-text-yellow-500'
            }
            `}
          >
            <p className="tw-text-md tw-font-medium tw-font-sans !tw-p-0 !tw-m-0">
              {data?.isMatched === true
                ? dt('status.nomina.PAID')
                : dt(`status.nomina.${
                    ['APPROVED', 'REJECTED'].includes(data?.status)
                      ? data.status
                      : 'IN_CREATED_NOMINA'
                  }`)}
            </p>
          </div>
        </div>
      </div >
    </>
  );
};

export default NominaContent;